import store from "../store";
import history from "../routes/History";
import { ROUTE_PATHS } from "./RoutesPaths";
import { EVENT_VIEW_TABS } from "./eventViewTabs";
import { setClientNotificationSeenRequest } from "../store/ClientPortal/Notifications/actions";

/**
 * Client Portal notification deep-linking (PROLINE-3641).
 *
 * Maps a notification `click_action` to a client-portal route.
 *   - `show_client_report` -> the event's Client Reports tab. `event_id` is the
 *     screen to open; `action_id` (the client report id) is carried in the URL
 *     so the tab can surface that row. Falls back to the events list when
 *     `event_id` is missing.
 */
export const clientPortalNotificationsActionsList = [
  {
    action: "show_client_report",
    route: ROUTE_PATHS.clientPortalViewEvent,
    paramSource: "event_id",
    tab: EVENT_VIEW_TABS.clientReports,
    fallbackRoute: ROUTE_PATHS.clientPortalEvents,
  },
];

export const setClientNotificationSeen = (id) => {
  store.dispatch(setClientNotificationSeenRequest(id));
};

export const handleClientPortalNotificationClick = ({
  id,
  click_action,
  action_id,
  event_id,
  is_seen,
}) => {
  if (!is_seen) setClientNotificationSeen(id);

  const target = clientPortalNotificationsActionsList.find(
    (elt) => elt.action === click_action,
  );
  if (!target?.route) return;

  const paramValue = target.paramSource === "event_id" ? event_id : action_id;
  if (paramValue == null) {
    if (target.fallbackRoute) history.push(target.fallbackRoute);
    return;
  }

  const params = new URLSearchParams();
  if (target.tab) params.set("tab", target.tab);
  if (action_id != null) params.set("report", String(action_id));

  history.push({
    pathname: target.route.replace(":id", paramValue),
    search: params.toString() ? `?${params.toString()}` : "",
  });
};
